import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
  apiKey: "AIzaSyBIcqMfSIBjjFyNCFp0vqgid6Z7MCwkskU",
  authDomain: "marioplan-react-252301.firebaseapp.com",
  databaseURL: "https://marioplan-react-252301.firebaseio.com",
  projectId: "marioplan-react-252301",
  storageBucket: "",
  messagingSenderId: "1041652285409",
  appId: "1:1041652285409:web:18c77d39008735ae689ca0"
};
// Initialize Firebase
firebase.initializeApp(config);
//firebase.firestore().settings({timestampsInSnapshots: true })

export default firebase;



// WEBPACK FOOTER //
// ./src/config/fbConfig.js